import React from 'react'
import {
    Box,
    Button,
    Grid,
} from '@material-ui/core'
import { businessUnits } from '../../../../store/slices'
import { useAppDispatch } from '../../../../store'
import { ROUTES } from '../../../../constants'
import { useHistory } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { SideBar } from '../../../../components/side-bar'
import { Content } from '../../../../components/content'
import { navLinksOrganization, validation } from '../../../../services'
import { Field, Form, Formik } from 'formik'
import { BusinessUnitProps } from '../../../../store/types'
import { CheckboxWithLabel, TextField } from 'formik-material-ui'

export function BusinessUnitCreatePage(): JSX.Element {
    const dispatch = useAppDispatch()
    const history = useHistory()

    const initialValues: BusinessUnitProps = { name: '', active: false}


    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
                dispatch(businessUnits.actions.create(values))
                    .then(unwrapResult)
                    .then(() => {
                        history.push(ROUTES.ORGANIZATION_BUSINESS_UNITS)
                    })
                setSubmitting(false)
            }}
        >
            {({ submitForm }) => (
                <Form>
                    <Box display="flex">
                        <SideBar navLinks={navLinksOrganization}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={submitForm}
                            >
                                Сохранить
                            </Button>
                        </SideBar>
                        <Content loading={false} notFoundContent={false} title={'Создание БЮ'}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Field
                                        component={TextField}
                                        label="Название"
                                        name="name"
                                        validate={validation.required}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <Field
                                        component={CheckboxWithLabel}
                                        Label={{ label: 'Активна' }}
                                        name="active"
                                        type="checkbox"
                                    />
                                </Grid>
                            </Grid>
                        </Content>
                    </Box>
                </Form>
            )}
        </Formik>
    )
}